import { render } from "./ViewPurchaseManagement.vue?vue&type=template&id=404eaf30&scoped=true"
import script from "./ViewPurchaseManagement.vue?vue&type=script&lang=js"
export * from "./ViewPurchaseManagement.vue?vue&type=script&lang=js"

import "./ViewPurchaseManagement.vue?vue&type=style&index=0&id=404eaf30&scoped=true&lang=css"

import exportComponent from "/home/hulk-suman/Music/Insidejob-admin-devlopment-1/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-404eaf30"]])

export default __exports__